import { render } from "./SmallPlatesView.vue?vue&type=template&id=12fa93cd"
import script from "./SmallPlatesView.vue?vue&type=script&lang=js"
export * from "./SmallPlatesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__